<template>
  <div class="setComponent">
    <el-table
      size="medium"
      :data="tableData"
      style="width: 100%">
      <!--<el-table-column-->
        <!--type="selection"-->
        <!--width="45">-->
      <!--</el-table-column>-->
      <el-table-column :label="$i18n.t('wm_lang_3806fe')">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            width="300"
            trigger="hover">
            <span>{{ scope.row.forwardAddr }}</span>
            <div slot="reference" class="cutout">{{ scope.row.forwardAddr }}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('wm_lang_7e951d')">
      <template slot-scope="scope">
        <span>{{ $moment(scope.row.operateTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
      </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('wm_lang_2b6bc0')+' IP'">
        <template slot-scope="scope">
          <span>{{ scope.row.operateIp }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('wm_lang_2f2786')">
        <template slot-scope="scope">
          <span>{{ scope.row.operateContent }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('wm_lang_a2b5f6')" width="240px">
        <template slot-scope="scope">
          <span>{{ scope.row.operateEmail }}</span>
        </template>
      </el-table-column>
      <el-table-column width="" :label="$i18n.t('wm_lang_de0f82')">
        <template slot-scope="scope">
          <span>{{ scope.row.forwardDiscardEnable ? $i18n.t('wm_lang_710ad0') : $i18n.t('wm_lang_7854b5') }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="page_block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <el-button type="primary" @click="cancelForm">{{$t("wm_lang_html_5f4112")}}</el-button>
    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
export default {
  name: 'forwardReplyLog',
  data () {
    return {
      // 表格
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 1
    }
  },
  mounted() {
    this.getLogList({limit: 10, page: 1});
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.getLogList({limit: 10, page: val});
    },
    cancelForm() {
      this.$router.push({name: 'forwardReply'});
    },
    getOperateContent(operateContent) {
      let cont = '';
      switch (operateContent) {
        case xmail.enums.DeliverOperateType.OPEN_FORWARD:
          cont = this.$i18n.t('custom_lang_0087');
          break;
        case xmail.enums.DeliverOperateType.CLOSE_FORWARD:
          cont = this.$i18n.t('custom_lang_0088');
          break;
        case xmail.enums.DeliverOperateType.UPTADE_FORWARD:
          cont = this.$i18n.t('custom_lang_0089');
          break;
        case xmail.enums.DeliverOperateType.UNKNOWN:
          cont = this.$i18n.t('custom_lang_0090');
          break;
      }
      return cont;
    },
    getLogList(opts) {
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Deliver.queryMailDeliverLogParamBuilder();
        pm.limit = opts.limit;
        pm.page = opts.page;
        api.Deliver.queryMailDeliverLog(pm, function (res) {
          console.log(res.data);
          if(res.data.code === 0) {
            if(Object.keys(res.data.data).length === 0) {
              return;
            }
            self.tableData = res.data.data.records;
            self.currentPage = res.data.data.current;
            self.total = res.data.data.total;
            self.pageSize = res.data.data.size;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
 .page_block{ text-align: right; margin:20px 0 0 0 }
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/forwardReplyLog.vue